import { ReactComponent as Add } from './svg/add.svg'
import { ReactComponent as ArrowDown } from './svg/arrow-down.svg'
import { ReactComponent as ArrowLeft } from './svg/arrow-left.svg'
import { ReactComponent as ArrowRightUp } from './svg/arrow-right-up.svg'
import { ReactComponent as ArrowRight } from './svg/arrow-right.svg'
import { ReactComponent as ArrowUp } from './svg/arrow-up.svg'
import { ReactComponent as Bell } from './svg/bell.svg'
import { ReactComponent as Briefcase } from './svg/briefcase.svg'
import { ReactComponent as Building } from './svg/building.svg'
import { ReactComponent as Calendar } from './svg/calendar.svg'
import { ReactComponent as Car } from './svg/car.svg'
import { ReactComponent as CarretDown } from './svg/carret-down.svg'
import { ReactComponent as CarreUp } from './svg/carret-up.svg'
import { ReactComponent as Chat } from './svg/chat.svg'
import { ReactComponent as CheckCircle } from './svg/check-circle.svg'
import { ReactComponent as Check } from './svg/check.svg'
import { ReactComponent as ChevronDown } from './svg/chevron-down.svg'
import { ReactComponent as ChevronLeft } from './svg/chevron-left.svg'
import { ReactComponent as ChevronRight } from './svg/chevron-right.svg'
import { ReactComponent as ChevronUp } from './svg/chevron-up.svg'
import { ReactComponent as Close } from './svg/close.svg'
import { ReactComponent as CommentLines } from './svg/comment-lines.svg'
import { ReactComponent as Crown } from './svg/crown.svg'
import { ReactComponent as Delet } from './svg/delet.svg'
import { ReactComponent as Download } from './svg/download.svg'
import { ReactComponent as Edit } from './svg/edit.svg'
import { ReactComponent as Envelope } from './svg/envelope.svg'
import { ReactComponent as Error } from './svg/error.svg'
import { ReactComponent as Expand } from './svg/expand.svg'
import { ReactComponent as EyeSlash } from './svg/eye-slash.svg'
import { ReactComponent as Eye } from './svg/eye.svg'
import { ReactComponent as FileAltWhite } from './svg/file-alt-white.svg'
import { ReactComponent as FileAlt } from './svg/file-alt.svg'
import { ReactComponent as Filter3Line } from './svg/filter-3-line.svg'
import { ReactComponent as FinancialAgent } from './svg/financial-agent.svg'
import { ReactComponent as Ghost } from './svg/ghost.svg'
import { ReactComponent as Groups } from './svg/groups.svg'
import { ReactComponent as House } from './svg/house.svg'
import { ReactComponent as Indicators } from './svg/indicators.svg'
import { ReactComponent as LayoutColumn } from './svg/layout-column.svg'
import { ReactComponent as Linear } from './svg/linear.svg'
import { ReactComponent as Lock } from './svg/lock.svg'
import { ReactComponent as ManagementFee } from './svg/management-fee.svg'
import { ReactComponent as MenuBurg } from './svg/menu-burg.svg'
import { ReactComponent as MenuEllipse } from './svg/menu-ellipse.svg'
import { ReactComponent as QuestionMark } from './svg/question-mark.svg'
import { ReactComponent as Save } from './svg/save.svg'
import { ReactComponent as Search } from './svg/search.svg'
import { ReactComponent as Settings } from './svg/settings.svg'
import { ReactComponent as User } from './svg/user.svg'

const IconsTypes = {
    add: Add,
    'arrow-down': ArrowDown,
    'arrow-left': ArrowLeft,
    'arrow-right': ArrowRight,
    'arrow-right-up': ArrowRightUp,
    'arrow-up': ArrowUp,
    briefcase: Briefcase,
    building: Building,
    calendar: Calendar,
    chat: Chat,
    check: Check,
    'carret-down': CarretDown,
    'carret-up': CarreUp,
    'chevron-down': ChevronDown,
    'chevron-left': ChevronLeft,
    'chevron-right': ChevronRight,
    'chevron-up': ChevronUp,
    close: Close,
    crown: Crown,
    delet: Delet,
    download: Download,
    edit: Edit,
    envelope: Envelope,
    expand: Expand,
    'eye-slash': EyeSlash,
    eye: Eye,
    'file-alt': FileAlt,
    'file-alt-white': FileAltWhite,
    'filter-3-line': Filter3Line,
    'financial-agent': FinancialAgent,
    groups: Groups,
    'layout-column': LayoutColumn,
    lock: Lock,
    'menu-burg': MenuBurg,
    'menu-ellipse': MenuEllipse,
    'question-mark': QuestionMark,
    search: Search,
    settings: Settings,
    user: User,
    ghost: Ghost,
    error: Error,
    success: CheckCircle,
    linear: Linear,
    save: Save,
    'comment-lines': CommentLines,
    'management-fee': ManagementFee,
    bell: Bell,
    house: House,
    car: Car,
    indicators: Indicators
}

export default IconsTypes

export type IconName =
    | 'add'
    | 'arrow-down'
    | 'arrow-left'
    | 'arrow-right'
    | 'arrow-right-up'
    | 'arrow-up'
    | 'briefcase'
    | 'building'
    | 'calendar'
    | 'carret-down'
    | 'carret-up'
    | 'chat'
    | 'check'
    | 'chevron-down'
    | 'chevron-left'
    | 'chevron-right'
    | 'chevron-up'
    | 'close'
    | 'crown'
    | 'delet'
    | 'download'
    | 'edit'
    | 'envelope'
    | 'expand'
    | 'eye-slash'
    | 'eye'
    | 'file-alt'
    | 'file-alt-white'
    | 'filter-3-line'
    | 'financial-agent'
    | 'groups'
    | 'layout-column'
    | 'lock'
    | 'menu-burg'
    | 'menu-ellipse'
    | 'question-mark'
    | 'search'
    | 'settings'
    | 'user'
    | 'ghost'
    | 'error'
    | 'success'
    | 'linear'
    | 'save'
    | 'comment-lines'
    | 'management-fee'
    | 'bell'
    | 'house'
    | 'car'
